import { Radio, Star } from "@phosphor-icons/react";

const cn = (...a) => a.filter(Boolean).join(" ");

export default function StationRow({ station, active, isPlayingThis, fav, onPlay, onFav }) {
  const tags = (station.tags || "").split(",").filter(Boolean).slice(0, 2);
  return (
    <div
      onClick={(e) => { e.stopPropagation(); onPlay(); }}
      data-testid={`station-row-${station.stationuuid}`}
      className={cn(
        "group cursor-pointer border-b border-[#E4E4E7] px-4 py-3 flex items-center gap-3 transition-colors min-h-[64px]",
        active ? "bg-[#18181B] text-white" : "hover:bg-[#F4F4F5] active:bg-[#F4F4F5]"
      )}
    >
      <div className={cn(
        "w-11 h-11 shrink-0 border flex items-center justify-center overflow-hidden",
        active ? "border-white/30" : "border-[#E4E4E7] bg-white"
      )}>
        {station.favicon ? (
          <img
            alt=""
            src={station.favicon}
            className="w-full h-full object-cover"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        ) : (
          <Radio size={20} weight="duotone" className={active ? "text-white" : "text-[#52525B]"} />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          {isPlayingThis && <span className="live-dot" style={{ background: "#FF2A00" }} />}
          <div className={cn("font-display font-bold text-sm tracking-tight truncate", active && "text-white")}>
            {station.name?.trim() || "Untitled"}
          </div>
        </div>
        <div className={cn(
          "mt-1 flex items-center gap-2 text-[0.65rem] font-mono-tech",
          active ? "text-white/60" : "text-[#52525B]"
        )}>
          {station.bitrate ? <span>{station.bitrate}K</span> : null}
          {tags.length ? <span className="truncate">· {tags.join(" · ")}</span> : null}
        </div>
      </div>
      <button
        onClick={(e) => { e.stopPropagation(); onFav(); }}
        data-testid={`fav-toggle-${station.stationuuid}`}
        className={cn(
          "shrink-0 w-11 h-11 flex items-center justify-center",
          fav
            ? "text-[#FF2A00]"
            : active
              ? "text-white/60 hover:text-white"
              : "text-[#A1A1AA] hover:text-[#18181B]"
        )}
        title={fav ? "Aus Favoriten entfernen" : "Zu Favoriten"}
      >
        <Star size={18} weight={fav ? "fill" : "regular"} />
      </button>
    </div>
  );
}
